import React from "react";
import "./scss/homePage.css"

export default function HomePage() {

  return (
    <div className="homeMiniProject">
      <h5>Demo Mini Project (Not Responsive Mobile)</h5>
    </div>
  );
}
